import React from 'react';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <div className="flex flex-col min-h-screen bg-bg-primary text-gray-600 font-body relative">
            <Header />
            <main className="flex-grow pt-24 pb-20">
                {children}
            </main>
            <Footer />
        </div>
    );
};

export default Layout;
